import { shallowEqual } from 'react-redux';
import { useSsSelector } from '~SpectateStore';
import {
    selectScoreboardById,
    selectIsVisualizationAvailable,
    selectScorecentreOptions,
    selectSportRadarScriptUrl,
    selectBetGeniusScriptUrl,
    selectBetGeniusSportUrl,
    selectHasScoreboard,
} from '~SpectateStore/selectors/scoreboardSelectors';

export const useHasScoreboard = eventId => useSsSelector(state => selectHasScoreboard(state, eventId));
export const useScoreboardById = eventId => useSsSelector(state => selectScoreboardById(state, eventId), shallowEqual);
export const useIsVisualizationAvailable = eventId => useSsSelector(state => selectIsVisualizationAvailable(state, eventId));
export const useScorecentreOptions = eventId => useSsSelector(state => selectScorecentreOptions(state, eventId));
export const useSportRadarScriptUrl = () => useSsSelector(selectSportRadarScriptUrl);
export const useBetGeniusScriptUrl = () => useSsSelector(selectBetGeniusScriptUrl);
export const useBetGeniusSportUrl = eventId => useSsSelector(state => selectBetGeniusSportUrl(state, eventId));
